const SNOWFLAKE_MCP_PATH =
  /^\/api\/v2\/databases\/[^/]+\/schemas\/[^/]+\/mcp-servers\/[^/]+$/i;

/**
 * Validates a Snowflake-managed MCP server URL, of the form
 * `https://<account>.snowflakecomputing.com/api/v2/databases/<db>/schemas/<schema>/mcp-servers/<name>`.
 * Underscores in the account host are replaced by hyphens, as Snowflake requires.
 * See https://docs.snowflake.com/en/user-guide/snowflake-cortex/cortex-agents-mcp
 */
export function snowflakeMcpUrl(input: string): string | null {
  const trimmed = input.trim();
  if (!trimmed) return null;
  const withScheme = /^[a-z]+:\/\//i.test(trimmed)
    ? trimmed
    : `https://${trimmed}`;

  let parsed: URL;
  try {
    parsed = new URL(withScheme);
  } catch {
    return null;
  }
  const host = parsed.hostname.replace(/_/g, '-');
  const path = parsed.pathname.replace(/\/+$/, '');
  if (
    parsed.protocol !== 'https:' ||
    !host.endsWith('.snowflakecomputing.com') ||
    !SNOWFLAKE_MCP_PATH.test(path)
  ) {
    return null;
  }
  return `https://${host}${path}`;
}

export function isSnowflakeMcpUrl(url: string): boolean {
  return /\.snowflakecomputing\.com\/api\/v2\/databases\/.+\/mcp-servers\//i.test(
    url
  );
}
